(() => {
  const keyFor = (section) => 'gcCollectionCols:' + section;
  const apply = (root, cols) => {
    const grid = root.querySelector('.gc-collection-product-grid');
    if (!grid || !cols) return;
    grid.setAttribute('data-gc-cols', cols);
    root.querySelectorAll('.gc-collection-grid-view__button').forEach((button) => {
      button.classList.toggle('is-active', button.dataset.gcGridCols === String(cols));
    });
  };
  const init = () => {
    document.querySelectorAll('[data-gc-collection-section]').forEach((root) => {
      const section = root.dataset.gcCollectionSection;
      let cols = null;
      try { cols = sessionStorage.getItem(keyFor(section)); } catch(e) {}
      if (!cols) cols = root.querySelector('.gc-collection-product-grid')?.dataset.gcDefaultCols || '4';
      apply(root, cols);
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-gc-grid-cols]');
    if (!button) return;
    const root = button.closest('[data-gc-collection-section]');
    if (!root) return;
    const cols = button.dataset.gcGridCols;
    apply(root, cols);
    try { sessionStorage.setItem(keyFor(root.dataset.gcCollectionSection), cols); } catch(e) {}
  });
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
  const observer = new MutationObserver((mutations) => {
    if (mutations.some((m) => Array.from(m.addedNodes || []).some((n) => n.nodeType === 1 && (n.id === 'ProductGridContainer' || n.querySelector?.('.gc-collection-product-grid'))))) init();
  });
  if (document.documentElement) observer.observe(document.documentElement,{childList:true,subtree:true});
})();